import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useHistory } from "react-router-dom";

import { NotificationToast } from "../components/Generic/Toast/NotificationToast";
import { Comment } from "../models/comment";
import CommentService from "../services/comment.service";
import { keysToSnake } from "../util/convertCamelCase";
import { CommentKeys } from "../util/queries";

const useActionComment = () => {
  const history = useHistory();

  const getAllComments = (
    order: string[] | string[][] = [["createdAt", "DESC"]],
    originId?: number,
    originTable?: string,
    page?: number,
    pageSize?: number,
    secondaryOriginId: string | number = ""
  ) => {
    return useQuery({
      enabled: !!originId && !!originTable,
      queryFn: async () => {
        const response = await CommentService.getAll(
          keysToSnake({
            order: JSON.stringify(order),
            originId,
            originTable,
            page,
            pageSize,
            secondaryOriginId,
          })
        );

        return response?.data || { count: 0, rows: [] };
      },
      queryKey: CommentKeys.getAndCountAll([
        order,
        originId,
        originTable,
        page,
        pageSize,
        secondaryOriginId,
      ]),
    });
  };

  const useCreateComment = (reload?: boolean, refetch?: () => void) => {
    return useMutation(
      ["comment.create"],
      (comment: Comment) => CommentService.create(keysToSnake(comment)),
      {
        onSuccess: () => {
          if (reload) history.go(0);
          if (refetch) refetch();
        },
        onError: (error: AxiosError<Error>) => {
          NotificationToast.error(error.response?.data.message);
        },
      }
    );
  };

  return {
    getAllComments,
    useCreateComment,
  };
};

export default useActionComment;
